const WRAP_CLASS = 'hm-slider-wrap'
const NAV_CLASS = 'hm-slider-nav'

export function ensureSliderNav(slider) {
    const parent = slider.parentElement
    if (!parent) return null

    let wrap = parent.classList.contains(WRAP_CLASS) ? parent : null

    if (!wrap) {
        wrap = document.createElement('div')
        wrap.className = WRAP_CLASS
        parent.insertBefore(wrap, slider)
        wrap.appendChild(slider)
    }

    let nav = wrap.querySelector(`.${NAV_CLASS}`)

    if (!nav) {
        nav = document.createElement('div')
        nav.className = NAV_CLASS
        wrap.appendChild(nav)
    }

    return nav
}
